import React, { Fragment, useState } from 'react'
import { Pagination } from '@CommonComponents/buttons'
import { useStateValue } from '@State'
import { addPeople, archiveMembers, updatePageNum } from '../actions'
import { ArchiveConfirmModal } from './ArchiveConfirmModal'
import { AddPeopleModal } from './AddPeopleModal'
import { toast } from '@CommonComponents/toast'
import { METable, itemIdxDisplayer } from '@CommonComponents'
import { ActionButtonPeople } from './ActionButtonPeople'
import { ActionButtonUnarchive } from './ActionButtonUnarchive'

export const PeopleTables = () => {
  const [currentState, dispatch] = useStateValue()

  const [showAddPeopleModal, setShowAddPeopleModal] = useState(false)
  const [peopleInfo, setPeopleInfo] = useState('')
  const [roleSelection, setRoleSelection] = useState('student')
  const [sectionSelection, setSectionSelection] = useState(
    currentState.sectionRowData[0].secName
  )
  const [paymentRecordSelection, setPaymentRecordSelection] = useState('no')
  const [notificationSelection, setNotificationSelection] = useState('no')
  const [archiveMembersModalOpen, setArchiveMembersModalOpen] = useState(false)
  const [enforceAccessFormValue, setEnforceAccessFormValue] = useState(
    currentState.daysOfAccess > 0
  )
  const [displayArchivedTable, setDisplayArchivedTable] = useState(false)

  const columns = [
    'Select',
    'Role',
    'Section',
    'SchoolID',
    'Last Name',
    'First Name',
    'Signup Date',
    'Last Login',
    'Email',
    'Actions',
  ]
  const archiveColumns = columns.slice(1, 10)

  const toggleAddPeopleModal = () => {
    setShowAddPeopleModal(!showAddPeopleModal)
  }

  const toggleArchiveMembersModal = () => {
    setArchiveMembersModalOpen(!archiveMembersModalOpen)
  }

  const showHideArchiveBtn = archiveList => {
    if (archiveList.length > 0) {
      return (
        <a
          className="btn btn-danger btn-myed btn-danger-myed mr-2"
          onClick={toggleArchiveMembersModal}
        >
          <i className="fa-regular fa-user-times fa-fw mr-2" /> Archive
        </a>
      )
    } else {
      return ''
    }
  }

  const dispatchArchiveMembers = async () => {
    let data = { ...currentState.filters }
    data.toBeArchived = currentState.toBeArchived
    data.pageNum = currentState.currentCourseMemPage
    data.archivedPageNum = currentState.currentArchivePage
    toggleArchiveMembersModal()
    try {
      let response = await archiveMembers(data, dispatch)
      if (response.status === 200) {
        toast.success('Successfully archived the selected student(s).')
      } else {
        toast.error('There was a problem trying to archive student(s).')
      }
    } catch (err) {
      toast.error('There was a problem trying to archive student(s).')
    }
  }

  const validatePeopleInfo = info => {
    if (!info) {
      throw new Error('Missing info for new user.')
    }
  }

  const resetAddPeopleForm = () => {
    setShowAddPeopleModal(false)
    setPeopleInfo('')
    setRoleSelection('student')
    setSectionSelection(currentState.sectionRowData[0].secName)
    setPaymentRecordSelection('no')
    setNotificationSelection('no')
  }

  const handleFormSubmit = async () => {
    try {
      validatePeopleInfo(peopleInfo)
    } catch (err) {
      toast.error(err.message)
      resetAddPeopleForm()
      return null
    }
    let data = { ...currentState.filters }
    data.people = peopleInfo
    data.role = roleSelection
    data.section = sectionSelection
    data.payment = paymentRecordSelection
    data.notify = notificationSelection
    data.enforceAccessDays = enforceAccessFormValue
    data.pageNum = currentState.currentCourseMemPage
    data.archivedPageNum = currentState.currentArchivePage

    try {
      let response = await addPeople(data, dispatch)
      resetAddPeopleForm()
      toast.info(`Results - ${response.data.results}`, { autoClose: false })
    } catch (err) {
      resetAddPeopleForm()
      toast.error('There was a problem adding people.')
    }
  }

  const addRemoveAll = () => {
    let studRows = currentState.peopleRowData.filter(
      row => row.role === 'student'
    )
    let archiveList = []
    if (studRows.length > currentState.toBeArchived.length) {
      for (let i = 0; i < studRows.length; i++) {
        archiveList.push(studRows[i].id)
      }
      dispatch({ type: 'UPDATE_TO_BE_ARCHIVED_MEMBERS', payload: archiveList })
    } else {
      dispatch({ type: 'UPDATE_TO_BE_ARCHIVED_MEMBERS', payload: [] })
    }
  }

  const addRemoveSingle = rowId => {
    if (currentState.toBeArchived.indexOf(rowId) === -1) {
      dispatch({
        type: 'UPDATE_TO_BE_ARCHIVED_MEMBERS',
        payload: [...currentState.toBeArchived, rowId],
      })
    } else {
      dispatch({
        type: 'UPDATE_TO_BE_ARCHIVED_MEMBERS',
        payload: currentState.toBeArchived.filter(id => id !== rowId),
      })
    }
  }

  const buildTableData = (peopleData, isArchivedTable) => {
    let cellRows = []
    peopleData.map((row, i) => {
      let newRow = [
        row.role === 'student' && !isArchivedTable && (
          <input
            type="checkbox"
            aria-label="select student"
            checked={currentState.toBeArchived.indexOf(row.id) > -1}
            onChange={() => addRemoveSingle(row.id)}
          />
        ),
        row.role,
        row.section,
        row.school_id,
        <a href={`/course/progress/${row.coursenum}/${row.userID}/`} key={i}>
          {row.lastName}
        </a>,
        <a href={`/course/progress/${row.coursenum}/${row.userID}/`} key={i}>
          {row.firstName}
        </a>,
        row.dateJoined,
        row.lastLogin,
        <a href={`mailto:${row.email}`} key={i}>
          {row.email}
        </a>,
        !isArchivedTable ? (
          <ActionButtonPeople
            user_id={row.id}
            account_id={row.userID}
            user_full_name={row.firstName + ' ' + row.lastName}
          />
        ) : (
          <ActionButtonUnarchive user_id={row.id} />
        ),
      ]
      if (isArchivedTable) {
        newRow = newRow.slice(1)
      }
      cellRows.push(newRow)
    })
    return cellRows
  }

  return (
    <Fragment>
      <div className="p-3 card-myed">
        <div className="pull-right mb-2">
          {showHideArchiveBtn(currentState.toBeArchived)}
          <a
            className="btn btn-myed btn-default btn-default-myed"
            onClick={toggleAddPeopleModal}
          >
            Add / Edit People
          </a>
        </div>
        <h3>Course Members</h3>
        <p>
          Course members
          {itemIdxDisplayer(
            currentState.memPageLimit,
            currentState.currentCourseMemPage,
            currentState.peopleRowData.length,
            currentState.peopleCount
          )}
          shown
        </p>
        {currentState.peopleRowData.filter(row => row.role === 'student')
          .length > 0 && (
          <label>
            <input
              type="checkbox"
              className="mr-3"
              checked={
                currentState.peopleRowData.filter(row => row.role === 'student')
                  .length === currentState.toBeArchived.length &&
                currentState.toBeArchived.length > 0
              }
              onChange={() => addRemoveAll()}
            />
            <span>Select students on page</span>
          </label>
        )}
        <METable
          columns={columns}
          data={buildTableData(currentState.peopleRowData, false)}
          columnCss={{ Actions: 'text-center' }}
        />
        <div className="text-center">
          {Math.ceil(currentState.peopleCount / currentState.memPageLimit) > 1 && (
            <Pagination
              label="Pagination, course members"
              currentPage={currentState.currentCourseMemPage}
              rate={currentState.memPageLimit}
              total={currentState.peopleCount}
              setCurrentPage={page =>
                updatePageNum(
                  {
                    page: page,
                    table: 'courseMember',
                    ...currentState.filters,
                  },
                  dispatch
                )
              }
            />
          )}
        </div>
      </div>

      {currentState.archivedRowData.length > 0 && (
        <div className="pull-right mb-3 mr-3">
          <a
            className="btn btn-link btn-sm"
            onClick={() => setDisplayArchivedTable(!displayArchivedTable)}
          >
            {!displayArchivedTable
              ? 'View Archived Course Members'
              : 'Hide Archived Course Members'}
          </a>
        </div>
      )}
      <div
        className={
          displayArchivedTable && currentState.archivedRowData.length > 0
            ? 'card-myed'
            : 'd-none'
        }
      >
        <h3>Archived Members</h3>
        <METable
          columns={archiveColumns}
          data={buildTableData(currentState.archivedRowData, true)}
          columnCss={{ Actions: 'text-center' }}
        />
        <div className="text-center">
          {Math.ceil(currentState.archivedCount / currentState.memPageLimit) > 1 && (
            <Pagination
              label="Pagination, archived members"
              currentPage={currentState.currentArchivePage}
              rate={currentState.memPageLimit}
              total={currentState.archivedCount}
              setCurrentPage={page =>
                updatePageNum(
                  {
                    page: page,
                    table: 'archivedMember',
                    ...currentState.filters,
                  },
                  dispatch
                )
              }
            />
          )}
        </div>
      </div>
      <AddPeopleModal
        showAddPeopleModal={showAddPeopleModal}
        toggleAddPeopleModal={toggleAddPeopleModal}
        handlePeopleInfoChange={e => setPeopleInfo(e.target.value)}
        handleRoleSelectionChange={e => setRoleSelection(e.target.value)}
        handleSectionSelection={e => setSectionSelection(e.target.value)}
        handlePaymentRecordSelection={e =>
          setPaymentRecordSelection(e.target.value)
        }
        handleNotificationSelection={e =>
          setNotificationSelection(e.target.value)
        }
        handleFormSubmit={handleFormSubmit}
        sections={currentState.sectionRowData}
        elevatedUser={currentState.elevatedUser}
        handleEnforceAccessDays={setEnforceAccessFormValue}
        daysOfAccess={currentState.daysOfAccess}
      />
      <ArchiveConfirmModal
        archiveMembersModalOpen={archiveMembersModalOpen}
        toggleArchiveMembersModal={toggleArchiveMembersModal}
        dispatchArchiveMembers={dispatchArchiveMembers}
      />
    </Fragment>
  )
}
